/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Missing_PermissionsInputs */

const en_toast_missing_permissions = /** @type {(inputs: Toast_Missing_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missing permissions`)
};

const nl_toast_missing_permissions = /** @type {(inputs: Toast_Missing_PermissionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontbrekende machtigingen`)
};

/**
* | output |
* | --- |
* | "Missing permissions" |
*
* @param {Toast_Missing_PermissionsInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_missing_permissions = /** @type {((inputs?: Toast_Missing_PermissionsInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Missing_PermissionsInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_missing_permissions(inputs)
	return en_toast_missing_permissions(inputs)
});